import React, { useState } from 'react';
import { post } from '../../../model/post';
import { StyledComponentProps } from '@material-ui/core/styles';
import Prompt from '../../../ui-components/Dialog/Prompt';
import Button from '../../../ui-components/Button/DeleteIconButton';
import { Tooltip } from '@material-ui/core';

interface IProps extends StyledComponentProps {
    post: post;
    deletePost: (id: string) => void;
}

export const DeleteButton = (props: IProps) => {
    const [open, setOpen] = useState(false);
    
    const confimDelete = () => {
        setOpen(false);
        props.deletePost(props.post._id);
    }

    return (
        <>
            <Tooltip title='Elimina'>
                <Button onClick={() => setOpen(true)}></Button>
            </Tooltip>
            <Prompt open={open}
                onCancel={() => setOpen(false)}
                onConfirm={confimDelete}
                confirmText='Elimina'
                cancelText='Annulla'
                icon='delete'
                text='Sei sicuro di voler cancellare il post?'>
            </Prompt>
        </>
    );
}

export const DeleteX = (props: { action: () => void, text: string }) => {

    const [open, setOpen] = useState(false);
    
    const confimDelete = () => {
        setOpen(false);
        props.action();
    }
    
    return (
        <>
            <Tooltip title='Elimina'>
                <Button onClick={() => setOpen(true)}></Button>
            </Tooltip>
            <Prompt open={open}
                onCancel={() => setOpen(false)}
                onConfirm={confimDelete}
                confirmText='Elimina'
                cancelText='Annulla'
                icon='delete'
                text={props.text}>
            </Prompt>
        </>
    );
}